// extracted by mini-css-extract-plugin
export default {"PolicyPage":"PolicyPage_PolicyPage__YeABR","PolicyPage__heading":"PolicyPage_PolicyPage__heading__J7ciN","PolicyPage__paragraph":"PolicyPage_PolicyPage__paragraph__9Udxv"};